const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20celebrity%20red%20carpet%20event%20with%20paparazzi%20flashing%20cameras%2C%20dark%20moody%20atmosphere%2C%20warm%20spotlight%20effect%2C%20cinematic%20photography%20style%2C%20mysterious%20and%20intense%20mood&width=800&height=560&seq=card-01-911&orientation=landscape',
    tag: '娱乐爆料',
    title: '2026年娱乐圈上半年最全塌房事件盘点',
    desc: '整理2026年上半年娱乐圈内引发广泛关注的各类事件，从恋情曝光到合约纠纷，一篇看完上半年所有大瓜。',
    time: '3小时前',
    views: '12.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20figure%20walking%20through%20a%20dark%20urban%20alleyway%20at%20night%2C%20dramatic%20street%20lighting%2C%20noir%20cinematography%20style%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20investigative%20journalism%20aesthetic&width=800&height=560&seq=card-02-911&orientation=landscape',
    tag: '网红翻车',
    title: '直播带货翻车名场面合集：这些网红都栽了',
    desc: '盘点近期直播带货领域最令人瞠目结舌的翻车现场，从虚假宣传到商品质量问题，吃瓜吃不停。',
    time: '6小时前',
    views: '9.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20corporate%20boardroom%20with%20scattered%20documents%20on%20a%20long%20table%2C%20dramatic%20lighting%20from%20a%20single%20overhead%20lamp%2C%20tense%20atmosphere%2C%20cinematic%20composition%2C%20dark%20wood%20furniture&width=800&height=560&seq=card-03-911&orientation=landscape',
    tag: '社会事件',
    title: '某上市公司内部邮件泄露引发行业震动',
    desc: '一份来自某知名上市公司的内部邮件在网络上流传，其中涉及的内容让整个行业都为之震惊。',
    time: '12小时前',
    views: '7.2万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20backstage%20area%20of%20a%20television%20studio%20with%20equipment%20and%2C%20warm%20production%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20broadcast%20environment%2C%20documentary%20style%20photography&width=800&height=560&seq=card-04-911&orientation=landscape',
    tag: '综艺揭秘',
    title: '热门综艺幕后故事大揭秘：那些不为人知的细节',
    desc: '深入揭秘当下最火综艺节目录制现场的真实内幕，台前幕后的反差让人意想不到。',
    time: '1天前',
    views: '5.6万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20penthouse%20interior%20with%20floor%20to%20ceiling%20windows%20overlooking%20a%20city%20skyline%20at%20night%2C%20modern%20minimalist%20design%2C%20soft%20warm%20ambient%20lighting%2C%20elegant%20and%20mysterious%20atmosphere&width=800&height=560&seq=card-05-911&orientation=landscape',
    tag: '明星私生活',
    title: '某流量明星私下真实生活状态曝光',
    desc: '镜头上光鲜亮丽的流量明星，私下里的生活状态与公众形象究竟有多大差距？最新爆料来了。',
    time: '1天前',
    views: '4.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20digital%20screen%20displaying%20social%20media%20trending%20topics%20with%20glowing%20red%20notifications%2C%20modern%20tech%20environment%2C%20dark%20background%20with%20warm%20accent%20lights%2C%20futuristic%20data%20visualization&width=800&height=560&seq=card-06-911&orientation=landscape',
    tag: '深度扒皮',
    title: '社交平台数据造假产业链完整深度调查',
    desc: '从粉丝量到互动数据，一篇长文揭开社交平台数据造假的全产业链运作模式，触目惊心。',
    time: '2天前',
    views: '3.8万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门<span className="text-primary-500">爆料</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              精选911吃瓜黑料最新事件，一站式获取最全爆料合集
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card, idx) => (
              <article
                key={idx}
                className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                <div className="relative w-full aspect-[16/11] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-bold bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-950 mb-2 line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {card.desc}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{card.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {card.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}